import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetDocumentUploadData = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IGetDocumentUploadDataRequestData): Promise<Types.IGetDocumentUploadDataResponseData> => {
            const { data } = await send<Types.IGetDocumentUploadDataRequestData, Types.IGetDocumentUploadDataResponseData>({
                ID: 35805,
                description: 'Get Document Upload Data',
                responses: [35806, 35807],
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
